<template>
  <v-column-avatar
    :width="width"
    :label="label"
    avatar-key="selfie"
    :nickname-key="nicknameKey"
    :nickname-overflow="nicknameOverflow"
    :link-page-name="detailPageName"
    :link-page-id="linkPageId"
    :align="align"
  />
</template>

<script>
import RouteConfig from "@/router/config";

export default {
  props: {
    width: {
      type: String,
      default: '132',
    },
    label: {
      type: String,
      default: '姓名',
    },
    nicknameKey: {
      type: String,
      default: 'student_name',
    },
    nicknameOverflow: {
      type: Boolean,
      default: true,
    },
    linkPageId: {
      type: String,
      default: 'id',
    },
    align: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    detailPageName: RouteConfig.studentDetail.name,
  }),
};
</script>
